import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };
  const SBHistory1 = {
    name: 'Secure Baseline History',
    imageUrl: '../../images/SBHistory.png',
    imageSize: "100%",
    bradius: 20,
  };
    const SBHistory2 = {
      name: 'Secure Baseline Snapshot',
      imageUrl: '../../images/SBHistoryExpand.png',
      imageSize: "100%",
      bradius: 20,
  };
  export const SBHistory = () => {
    return (
      <div style={helpcanvas}>
        <div
        style={{ marginLeft: "310px" }}
        ></div>
        <div style={helptitle}><b>Secure Baseline Scan History</b><br/><br/>
        Any existing secure baseline scans that have either been completed or cancelled are shown in the secure baseline scan history table.<br/><br/>
        The information displayed includes scan names, the targets scanned, individuals who issued the scan, start and end dates, no. of failed tests, no. of rules, passed rate, 
        grade, mitigations, and Actions to take<br/><br/>
        By default, the scan history table will show 10 results. However, depending on the volume of scans you have 
        performed previously, there are additional features allowing you to search or apply filters to find the 
        information you need quickly.<br/><br/>
        Search box - Type the name of the specific scan you are looking for in the searchbox to find it quickly.<br/><br/>
        Take Action<br/><br/>
        Within the table, you can go to the Action column to create an action - either delete a scan or begin building a mitigation plan.<br/><br/>
        Please note that the delete scan icon is not shown when there is a mitigation plan in place for this vulnerability scan. In addition, the create a mitigation plan option
        is not shown when there are zero vulnerabilities or when all targets have already been assigned to a pre-existing plan.<br/><br/>
        Should a new mitigation plan be required, select the three dots under Action and a mitigation plan builder will appear. For help on how to create a mitigation plan, click 
        Mitigation Planning-Create a Mitigation from the side navigation bar on the page.

        </div>
        <div style={helpimg}>
        <img
          src={SBHistory1.imageUrl}
          alt={'Image of ' + SBHistory1.name}
          style={{
            width: SBHistory1.imageSize,
            borderRadius: SBHistory1.bradius,
          }}
        />
        </div>
      </div>
    );
  };
  
  